import { Grid, IconButton, Tooltip } from "@material-ui/core";
import { Block, Save } from "@material-ui/icons";
import CommonButton from "app/common/Component/Button/CommonButton";
import ConfirmPopup from "app/common/Component/Popup/ConfirmPopup";
import PopupForm from "app/common/Component/Popup/PopupForm";
import TableComponent from "app/common/Component/Table/TableComponent";
import IconAddNew from "app/common/Icon/IconAddNew";
import IconDelete from "app/common/Icon/IconDelete";
import IconPen from "app/common/Icon/IconPen";
import { getCurrentStaff } from "app/common/LocalFunction";
import GlobitsPagingAutocomplete from "app/common/form/GlobitsPagingAutocomplete";
import GlobitsTextField from "app/common/form/GlobitsTextField";
import { pagingStaff } from "app/services/StaffService";
import { useStore } from "app/stores";
import { observer } from "mobx-react";
import { memo, useEffect, useState } from "react";
import * as Yup from 'yup';

const ScreenTemplatePopup = ({ handleClose, chooseValue, openValue, notchoose, hideSelectCheckbox = false }) => {
    const [listSelected, setListSelected] = useState([])
    const {
        listScreenTemplateByStaffAndScreen,
        handleChangeFormSearchByScreen,
        searchScreenTemplateByStaff,
        openConfirmDelete,
        handleClosePopup,
        handleDeleteScreen,
        handleConfirmDeleteScreen,
        handleOpenFormCreateOrEditScreen,
        openFormCreateOrEdit,
        selectedScreenTemplateByStaff,
        resetStore
    } =
        useStore().managementStore.screenTemplateStore;
    const [staff, setStaff] = useState(false);

    useEffect(() => {
        let currenStaff = getCurrentStaff()
        if (currenStaff) setStaff(currenStaff);
        handleChangeFormSearchByScreen({ screenCode: openValue?.screenCode, clientFieldCode: openValue?.clientCode, staffId: currenStaff?.id });
        return () => {
            resetStore();
            setListSelected([])
        };
    }, [])

    return (
        <PopupForm
            open={openValue?.open}
            size="lg" height="75vh"
            handleClose={handleClose}
            title={openValue?.title}
            formik={{
                initialValues: {
                    ...searchScreenTemplateByStaff,
                    screenCode: openValue?.screenCode,
                    clientFieldCode: openValue?.clientCode,
                    staff: staff,
                    isStaff: true,
                },
                onSubmit: async (values) => {
                    handleChangeFormSearchByScreen(values)
                },
                enableReinitialize: true,
            }}
            action={() => {
                return (
                    <div className="flex-center gap-1">
                        {!notchoose && !hideSelectCheckbox &&
                            <CommonButton onClick={() => {
                                chooseValue(listSelected);
                                handleClose();
                            }}
                            >
                                <Save className="mr-2" />  Chọn
                            </CommonButton>
                        }
                        <CommonButton className="btn-gray" onClick={handleClose}>
                            <Block className="mr-2" />  Hủy
                        </CommonButton>
                    </div>
                )
            }}
        >
            {({ setFieldValue, values }) => {
                return (
                    <>
                        <Grid container spacing={1}>
                            <Grid item xs={12}>
                                <div className="flex-between align-center">
                                    <CommonButton onClick={() => handleOpenFormCreateOrEditScreen()}>
                                        <IconAddNew className='mr-2' />
                                        Thêm mới
                                    </CommonButton>
                                    <div className="flex-center gap-2" style={{ width: "70%" }}>
                                        {!staff &&
                                            <GlobitsPagingAutocomplete api={pagingStaff} name="staffId"
                                                displayLabel="staffName" label="Người tạo" />
                                        }
                                        <GlobitsTextField name="keyword" label="Giá trị" />
                                        <CommonButton className="mt-3" style={{ width: "30%" }}
                                            onClick={() => handleChangeFormSearchByScreen(values)}
                                        >
                                            Tìm kiếm
                                        </CommonButton>
                                    </div>
                                </div>
                            </Grid>
                            {/* {console.log("values?.clientFieldCode",values?.clientFieldCode?.includes("howToUse" || "group_visit") )} */}
                            <Grid item xs={12} md={12}>
                                <h5>Danh sách giá trị</h5>
                            </Grid>
                            <Grid item sm={12}>
                                <TableComponent
                                    data={listScreenTemplateByStaffAndScreen?.content || []}
                                    titleNodata={"Không có dữ liệu"}
                                    showOrdinalNumbers
                                    selectType={!notchoose && !hideSelectCheckbox ? "multi" : null}
                                    initStateRow={listSelected}
                                    handleChangeSelectedRows={(selectedRows) => {
                                        setFieldValue("selectedTemplate", selectedRows)
                                        setListSelected(selectedRows)
                                    }}
                                    columns={[
                                        { field: "staff.staffName", title: "Người tạo" },
                                        { field: "abbreviation", title: "Viết tắt", isHide: (!values?.clientFieldCode?.includes("group_visit") && !values?.clientFieldCode?.includes("group_visit")) },
                                        { field: "value", title: "Giá trị", width: "50%" },
                                        {
                                            field: "", title: "TT",
                                            align: "center",
                                            render: (val) => (
                                                <div className="flex-center gap-1">
                                                    <Tooltip title="Chỉnh sửa">
                                                        <IconButton size="small"
                                                            onClick={() => handleOpenFormCreateOrEditScreen(val?.id)}
                                                        >
                                                            <IconPen />
                                                        </IconButton>
                                                    </Tooltip>
                                                    <Tooltip title="Xóa">
                                                        <IconButton size="small"
                                                            onClick={() => handleDeleteScreen(val)}
                                                        >
                                                            <IconDelete />
                                                        </IconButton>
                                                    </Tooltip>
                                                </div>
                                            )
                                        },
                                    ]}
                                    dataPagination={{
                                        pageIndex: searchScreenTemplateByStaff?.pageIndex,
                                        pageSize: searchScreenTemplateByStaff?.pageSize,
                                        totalElements: listScreenTemplateByStaffAndScreen?.totalElements,
                                        totalPages: listScreenTemplateByStaffAndScreen?.totalPages,
                                        setPageIndex: pageIndex => handleChangeFormSearchByScreen({ pageIndex }),
                                        setPageSize: pageSize => handleChangeFormSearchByScreen({ pageSize, pageIndex: 1 }),
                                    }}
                                />
                            </Grid>
                        </Grid>

                        <ConfirmPopup
                            open={openConfirmDelete}
                            onClose={handleClosePopup}
                            text="Bạn có chắc chắn muốn xóa bản ghi này?"
                            isNotAPromise
                            onConfirm={async () => {
                                setListSelected(prev => {
                                    const newList = prev?.filter(item => item.id !== selectedScreenTemplateByStaff?.id)
                                    return newList
                                })
                                await handleConfirmDeleteScreen()
                                handleClosePopup()
                            }}
                        />

                        {openFormCreateOrEdit && (
                            <CreateEditPopupScreenTemPlate open={openFormCreateOrEdit}
                                handleClose={handleClosePopup} value={values} />
                        )
                        }
                    </>
                )
            }}
        </PopupForm>
    )
}

export default memo(observer(ScreenTemplatePopup));

const CreateEditPopupScreenTemPlate = ({ open, handleClose, value }) => {
    const { saveConceptTemplate, selectedScreenTemplateByStaff } = useStore().managementStore.screenTemplateStore;
    const validationSchema = Yup.object().shape({
        value: Yup.string().required("Chưa nhập giá trị!").nullable(),
        staff: Yup.object().required("Chưa nhập người tạo").nullable()
    });
    return (
        <PopupForm
            open={open}
            size="sm"
            handleClose={handleClose}
            title={value?.id ? "Chỉnh sửa" : "Thêm mới"}
            formik={{
                initialValues: {
                    ...selectedScreenTemplateByStaff,
                    screenCode: value?.screenCode,
                    clientCode: value?.clientFieldCode,
                },
                onSubmit: async (values, { setSubmitting }) => {
                    await saveConceptTemplate(values, { setSubmitting });
                    handleClose();
                },
                enableReinitialize: true,
                validationSchema: validationSchema,
            }}
            action={({ values }) => (
                <>
                    <CommonButton className="mr-2" variant="contained" type="submit">
                        Lưu
                    </CommonButton>

                    <CommonButton className="btn-gray" variant="contained" onClick={handleClose}>
                        Hủy
                    </CommonButton>
                </>
            )}
        >
            <Grid container spacing={1}>
                <Grid item xs={12} md={12}>
                    <GlobitsPagingAutocomplete api={pagingStaff} name="staff" requiredLabel
                        displayLabel="staffName" label="Người tạo" />
                </Grid>
                {(value?.clientFieldCode?.includes("howToUse") || value?.clientFieldCode?.includes("group_visit")) &&
                    <Grid item xs={12} md={12}>
                        <GlobitsTextField name="abbreviation" label="Viết tắt giá trị" />
                    </Grid>
                }
                <Grid item xs={12} md={12}>
                    <GlobitsTextField isTextArea size={3} name="value" label="Giá trị" requiredLabel />
                </Grid>
            </Grid>
        </PopupForm>
    )
}

